import React from 'react';
import TextBlock from './TextBlock';
import { SharedTextProps } from './constants';

export { TextVariant } from './constants';

export type TextProps = SharedTextProps & {
  content?: React.ReactNode | React.ReactNode[] | string | number | null;
};

export default function Text({ content, ...props }: TextProps) {
  if (content === null || content === undefined || content === '') {
    return null;
  }

  return <TextBlock {...props}>{content}</TextBlock>;
}
